module.exports = __webpack_public_path__ + "img/ic-stop.e1154adb.svg";